import * as style from '../utils/general_style';
import CTAButton from '../components/global/CTAButton';
import img1 from '../assets/maison-plan.jpg';
import img2 from '../assets/G2_1.jpg';
import icon1 from '../assets/icons-4.png';
import icon2 from '../assets/icons-2.png';

function Presentation() {
	const avantages = [
		'Devis sur mesure adapté à vos besoins',
		'Programme conforme à la loi ELAN',
		'Intervention France entière'
	];

	const etapes = [
		'Je réalise mon devis en moins de 5 min pour une étude de sol G1 ou G2',
		'Je commande en ligne mon étude et transmets les documents nécessaires',
		'Je reçois la confirmation de mon rendez-vous pour mon étude de sol',
		'Une équipe géotechnique intervient sur le terrain pour réaliser les sondages',
		`Je reçois le rapport d'étude de sol réalisé par l'entreprise partenaire de PRESENTIS`
	];

	const formuleComplete = [
		'Une enquête documentaire',
		'Une synthèse des archives', 
		`Une visite de site et des investigations géotechniques afin de déterminer la nature des sols et d'apprécier leur sensibilité au risque de retrait/gonflement des argiles, ainsi qu'aux autres risques géotechniques`,
		'Essais en laboratoire',
		`Rapport : un rapport d'étude est établi pour caractériser la nature des risques et maîtriser leurs conséquences`,
		'Enquête documentaire - analyse du projet'
	];

	const formuleTerrain = [
		'Etude de site - première identification des risques présentés par le site',
		'Amené repli',
		'4 sondages au pénétromètres',
		'3 reconnaissances à la tarière'
	];

	const objectifs = [
		'Construire plus, mieux et moins cher',
		'Restructurer et renforcer le secteur du logement social',
		'Répondre aux besoins de chacun et favoriser la mixité sociale',
		'Améliorer le cadre de vie et renforcer la cohésion sociale'
	];

	let toHide = true;

	return (
        <div className='AppBody'>
			<section style={{...style.COLUMN_CENTER, ...style.ELEMENT_BLOCK_GREY}}>
				<h2>Bailleurs sociaux, aménageurs, promoteurs, urbanistes, locataires,<br /> propriétaires, collectivités territoriales, professionnels de l'immobilier, syndics.</h2>
				<article style={{...style.ROW_SPACE_BETWEEN, marginBottom: style.SPACE.large}}>
					<div style={{width: '35%', height: '100%', overflow: 'hidden'}}>
						<img src={img1} alt={`maquette de maison sur un plan d'architecte`}/>
					</div>
					<div style={{...style.COLUMN_CENTER, width: '62%'}}>
						<div className='paragraph' style={{marginBottom: style.SPACE.medium}}>
							<p>Laissez-nous vous guider dans la réalisation des investigations nécessaires et obligatoires à la vente des terrains de vos clients.</p>
							<p>Mais également dans l'optimisation de votre achat avec notre service d'estimation et d'études des sols sur mesure. </p>
							<p>Nous sommes là pour vous accompagner vers une décision éclairée et vous assurer que chaque pas que vous faites repose sur un sol solide</p>
						</div>
						<CTAButton />
					</div>
				</article>
			</section>
			<section className='paragraph' style={style.ELEMENT_BLOCK_WHITE}>
				<h2>Pourquoi passer par <span style={style.PRESENTIS}>Presentis</span> ?</h2>
				<p>L'étude géotechnique représente en moyenne 1 % du prix de la construction. Ce coût peut paraître élevé. Mais avec une étude de sol, vous pourrez réaliser des économies sur le prix de l'assurance dommages-ouvrage souscrite lors de la signature du contrat de construction.</p>
				<p><span style={style.PRESENTIS}>Presentis</span> vous garantit les meilleurs prix pour une étude complète et adaptée à vos besoins.</p>
				<article style={style.ROW_SPACE_BETWEEN}>
					<div>
						<p>Les avantages de <span style={style.PRESENTIS}>Presentis</span> :</p>
						{avantages.map((avantage, index) => (
							<p key={index}>&emsp; &#9656; {avantage}</p>
						))}
					</div>
					<div style={{width: '100px', height: '100px'}}>
						<img src={icon1} alt={'icone claquement de doigt'} />
					</div>
				</article>
			</section>
			<section style={style.ELEMENT_BLOCK_GREY}>
				<h2>5 étapes pour une étude de sol avec <span style={style.PRESENTIS}>Presentis</span></h2>
				{etapes.map((etape, index) => (
					<p key={index}>&emsp; &#9656; {etape.split('PRESENTIS').flatMap((item, index) => [item, <span key={index} style={style.PRESENTIS}>Presentis</span>]).slice(0, -1)}</p>
				))}
			</section>
			<section style={style.ELEMENT_BLOCK_WHITE}>
				<h2>Programme de la loi Elan avec <span style={style.PRESENTIS}>Presentis</span></h2>
				<article style={{...style.ROW_SPACE_BETWEEN, marginBottom: style.SPACE.large}}>
					<div style={{width:'30%', height: '422px', overflow: 'hidden'}}>
						<img src={img2} alt={'homme devant sa machine'} style={{objectPosition: '38%'}} />
					</div>
					<div className='paragraph' style={{...style.COLUMN_CENTER, width: '68%', alignItems: 'start'}}>
						<h3>Notre formule complète :</h3>
						{formuleComplete.map((listItem, index) => (
							<p key={index}>&emsp; &#9656; {listItem}</p>
						))}
						{!toHide && 
							<><h3>Notre formule sur le terrain</h3>
							{formuleTerrain.map((listItem, index) => (
								<p key={index}>&emsp; &#9656; {listItem}</p>
							))}</>
						}
					</div>
				</article>
			</section>
			<section style={style.ELEMENT_BLOCK_GREY}>
				<h2><span style={style.PRESENTIS}>Presentis</span> a pour objectifs de vous aider à :</h2>
				<article style={style.ROW_SPACE_AROUND}>
					<div className='paragraph'>
						{objectifs.map((objectif, index) => (
							<p key={index}>&emsp; &#9656; {objectif}</p>
						))}
					</div>
					<div style={{width: '80px', height: '80px'}}>
						<img src={icon2} alt={'icone bonhomme avec des flèches'} />
					</div>
				</article>
			</section>
        </div>
	);
};

export default Presentation;